<template>
  <div class="recommend">
    <div class="recommend__dialog">
      <div class="recommend__letter" v-if="showLetter">
        <div
          class="recommend__letter__closeBtn"
          ref="closeDialog1"
          @click="closeDialog('closeDialog1')"
        ></div>
        <div class="recommend__letter__body">
          <div class="letterContent">
            <p>家长您好：</p>
            <p>
              网校的学员来自全国各地，但是就像您了解到的，同一个地区同年级小朋友的英文水平也会存在很大差异，所以为了帮助家长们在网校选到适合孩子自身英语水平的课程，特此设置了课程定级环节。
            </p>
            <p>
              在这里，您将看到一些与孩子英语学习有关的问题，请根据孩子的实际情况作答。
            </p>
          </div>
          <div class="btn">
            <span @click="startDegree"></span>
          </div>
        </div>
      </div>
      <div class="recommend__content" v-if="!showLetter">
        <div class="recommend__content__header">
          <div><span>请根据孩子的实际情况作答</span></div>
        </div>
        <div
          class="recommend__content__closeBtn"
          ref="closeDialog2"
          @click="closeDialog('closeDialog2')"
        ></div>
        <div class="recommend__body">
          <div class="recommend__body__content">
            <div class="recommend__body__header">
              <span class="header-title"
                >问题{{ degreeStep + 1 }}：{{ question.name }}</span
              >
            </div>
            <div class="recommend__body__optionContent">
              <div class="two-queue" v-if="question.option_list.length > 4">
                <div class="left-queue">
                  <div
                    class="option"
                    @mouseover="showTitle($event, 2, item.name)"
                    @mouseout="closeTitle($event)"
                    :class="{
                      selected:
                        selectOption.length !== 0 &&
                        selectOption[degreeStep] &&
                        selectOption[degreeStep].selectOption === index
                    }"
                    v-for="(item, index) in question.option_list.slice(0, 4)"
                    :key="index"
                    @click="selectContent(degreeStep, index, question.option_list[index])"
                  >
                    {{ item.name }}
                  </div>
                </div>
                <div class="right-queue">
                  <div
                    class="option"
                    @mouseover="showTitle($event, 2, item.name)"
                    @mouseout="closeTitle($event)"
                    :class="{
                      selected:
                        selectOption.length !== 0 &&
                        selectOption[degreeStep] &&
                        selectOption[degreeStep].selectOption === index
                    }"
                    v-for="(item, index) in question.option_list.slice(4)"
                    :key="index"
                    @click="selectContent(degreeStep, index, question.option_list[index])"
                  >
                    {{ item.name }}
                  </div>
                </div>
              </div>
              <div class="one-queue" v-else>
                <div class="center-queue">
                  <div
                    class="option"
                    @mouseover="showTitle($event, 1, item.name)"
                    @mouseout="closeTitle($event)"
                    :class="[
                      { longOption: isOptionTooLong(question.option_list) },
                      { shortOption: !isOptionTooLong(question.option_list) },
                      {
                        selected:
                          selectOption.length !== 0 &&
                          selectOption[degreeStep] &&
                          selectOption[degreeStep].selectOption === index
                      }
                    ]"
                    v-for="(item, index) in question.option_list"
                    :key="index"
                    @click="selectContent(degreeStep, index, question.option_list[index])"
                  >
                    {{ item.name }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="recommend__body__tips"
              v-if="
                selectOption.length > 0 &&
                  selectOption[degreeStep] &&
                  nextQuestionId > -1 &&
                  needTest
              "
            >
              接下来进入答题测评环节，请家长监督小朋友独立答题。
            </div>
            <div
              class="recommend__body__btn"
              v-show="selectOption.length > 0 && selectOption[degreeStep]"
            >
              <span
                ref="nextStep"
                @click="nextStep"
                :class="[
                  { nextStep: nextQuestionId > -1 || !needTest },
                  { toTest: nextQuestionId > -1 && needTest }
                ]"
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { CourseCenter } from '@/networks/api'
import types from '@/store/types'
import { login } from '@/util/user'
export default {
  name: 'grading-question',
  props: ['data', 'backToCourseCenter'],
  data() {
    return {
      showLetter: true,
      degreeStep: 0,
      selectOption: [],
      nextQuestionId: -1,
      needTest: false,
      testUrl: '',
      question: {
        grading_id: 61,
        id: 161,
        name: '假数据问题一',
        option_list: [
          {
            id: 336,
            name: '假选项1',
            next_question_id: 162,
            sort_index: 1
          },
          {
            id: 337,
            name: '假选项2',
            next_question_id: 163,
            sort_index: 1
          }
        ]
      },
      optionGradeId: 0,
      difficultyName: ''
    }
  },
  created() {
    this.question = this.data.question
  },
  computed: {
    ...mapState({
      userIsLogin: state => state.userIsLogin
    })
  },
  methods: {
    /**
     * 当选项内容过长，moushover 添加dom展示所有内容
     * @event 事件
     * @queueType:boolean 一列选项： 1 ；两列选项：2
     * @content:object 选项内容
     */
    showTitle(event, queueType, content) {
      let title = ''
      title = content.length > 28 ? content : ''
      if (title) {
        var ele = event.target
        ele.title = ''
        var showEle = document.createElement('div')
        showEle.id = 'eleTitle'
        showEle.innerHTML = title
        showEle.style.position = 'absolute'
        showEle.style.marginTop = '-14px'
        showEle.style.border = '1px solid #CCC'
        showEle.style.padding = '3px 10px'
        showEle.style.borderRadius = '5px'
        showEle.style.background = 'white'
        ele.parentNode&&ele.parentNode.insertBefore(showEle, ele.nextElementSibling)
      }
    },
    /**
     * mouseout移除元素eleTitle
     * @event 事件
     */
    closeTitle(event) {
      var ele = event.target
      var eleTitle = document.getElementById('eleTitle')
      if (eleTitle) {
        ele.parentNode.removeChild(eleTitle)
      }
    },
    /** 关闭弹窗 */
    closeDialog(type) {
      const XESLog = new this.$XESLog({
        type: 'xeslog-closeGrading',
        clickId: '1.2.36',
        problemid: this.degreeStep
      })
      if (type === 'closeDialog1') {
        XESLog.push({ eventname: 'click', target: this.$refs.closeDialog1 }, this.$route)
      } else {
        XESLog.push({ eventname: 'click', target: this.$refs.closeDialog2 }, this.$route)
      }
      this.$store.commit('SET_SHOWGRAIDNGQUESTION', false)
    },
    /** 一封信下一步 */
    startDegree() {
      this.showLetter = false
    },
    /** 定级下一步 */
    async nextStep() {
      if (this.needTest) {
        const XESLog = new this.$XESLog({
          type: 'xeslog-grdingNextStep',
          clickId: '1.2.35',
          userIsLogin: this.userIsLogin,
          buttonName: 'toExam',
          problemid: this.degreeStep,
          index: this.selectOption[this.degreeStep].selectOption,
          answer: this.selectOption[this.degreeStep].name,
          difficulty: this.difficultyName
        })
        XESLog.push({ eventname: 'click', target: this.$refs.nextStep }, this.$route)
        if (this.userIsLogin) {
          this.$store.commit('SET_SHOWGRAIDNGQUESTION', false)
          window.open(this.testUrl)
        } else {
          login()
        }
      } else {
        try {
          const XESLog = new this.$XESLog({
            type: 'xeslog-grdingNextStep',
            clickId: '1.2.35',
            problemid: this.degreeStep,
            buttonName: 'nextStep',
            index: this.selectOption[this.degreeStep].selectOption,
            answer: this.selectOption[this.degreeStep].name
          })
          XESLog.push({ eventname: 'click', target: this.$refs.nextStep }, this.$route)
          if (this.nextQuestionId === 0) {
            this.$store.commit('SET_SHOWGRAIDNGQUESTION', false)
            this.$store.commit('SET_SHOWGRADINGRESULT', true)
          } else {
            let { grading_id } = this.question
            const { data } = await CourseCenter.difficultGuideNextQues({
              gradingId: grading_id,
              nextquestionId: this.nextQuestionId
            })
            this.question = data.data
            this.degreeStep++
          }
        } catch (e) {
          console.log(e)
        }
      }
    },
    /**
     * 选择选项
     * @stepIndex:int 第几步,从0开始
     * @optionIndex:int 选项序号,从0开始
     * @optionItem:object 选项内容
     */
    async selectContent(stepIndex, optionIndex, optionItem) {
      try {
        this.$set(this.selectOption, stepIndex, {
          selectOption: optionIndex,
          name: optionItem.name,
          id: optionItem.id
        })
        this.nextQuestionId = optionItem.next_question_id
        if (stepIndex === 0 && optionItem.grade_id > 0) {
          this.optionGradeId = optionItem.grade_id
        }
        if (this.nextQuestionId === 0) {
          let { grading_id } = this.question
          let idList = []
          for (let i = 0, len = this.selectOption.length; i < len; i++) {
            idList.push(this.selectOption[i].id)
          }
          let gradeId = -1
          if (this.optionGradeId > 0) {
            gradeId = this.optionGradeId
          } else if (this.$route.params.grade) {
            gradeId = parseInt(this.$route.params.grade)
          } else {
            gradeId = this.backToCourseCenter.gradeId
          }
          let params = {
            option_ids: idList.join(','),
            grading_id: grading_id,
            grade_id: gradeId
          }
          let subject = ''
          if (this.$route.params.subject) {
            subject = this.$route.params.subject
          } else {
            subject = this.backToCourseCenter.subjectAlias
          }
          let { data } = await CourseCenter.getDifficultDegree(params)
          if (data.data.need_exam === 2) {
            this.needTest = true
            this.difficultyName = data.data.difficulty_name
            this.testUrl = `https://exam.xueersi.com/exam-pc/grading/exam/${data.data.stu_grade_id}/${data.data.stu_level_id}/${subject}`
          } else {
            this.needTest = false
            this.$store.commit(types.SET_DIFFICULT_DEGREE, data)
          }
        } else {
          this.needTest = false
        }
      } catch (e) {
        console.log(e)
      }
    },
    /**
     * 一列的时候 选择的字符长度是否大于12
     * @optionList:array 选项字符的长度是否大于12
     */
    isOptionTooLong(optionList) {
      for (let i = 0; i < optionList.length; i++) {
        if (optionList[i].name.length > 12) {
          return true
        }
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/entry';
@include b(recommend) {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  -webkit-overflow-scrolling: touch;
  outline: 0;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: rgba($color: rgb(27, 27, 27), $alpha: 0.7);
  @include e(dialog) {
    width: 894px;
    position: absolute;
    margin: 10px auto;
    left: 0;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);
  }
  @include e(letter) {
    height: 531px;
    position: relative;
    // text-align: center;
    background: url('./img/letterBackground.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    @include e(closeBtn) {
      position: absolute;
      top: -13px;
      right: 18px;
      width: 61px;
      height: 67px;
      z-index: 1051;
      cursor: pointer;
      background-image: url('./img/closeBtn.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      &:hover {
        background-image: url('./img/closeBtn-click.png');
      }
    }
    @include e(body) {
      height: 501px;
      overflow: hidden;
      .letterContent {
        margin-top: 69px;
        margin-left: 117px;
        margin-right: 121px;
        p {
          font-size: 21px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: rgba(83, 71, 95, 1);
          line-height: 50px;
          &:nth-child(1) {
            text-align: left;
          }
          &:nth-child(2) {
            text-indent: 4rem;
          }
          &:nth-child(3) {
            text-indent: 4rem;
          }
        }
      }
      .btn {
        margin-top: 40px;
        cursor: pointer;
        text-align: center;
        span {
          display: inline-block;
          vertical-align: middle;
          width: 285px;
          height: 81px;
          background-image: url('./img/nextStep.png');
          background-repeat: no-repeat;
          background-position: center;
          background-size: cover;
          &:hover {
            background-image: url('./img/nextStep-hover.png');
          }
          &:active {
            background-image: url('./img/nextStep-active.png');
          }
        }
      }
    }
  }
  @include e(content) {
    position: relative;
    outline: 0;
    @include e(header) {
      position: absolute;
      top: -50px;
      width: 894px;
      height: 77px;
      display: flex;
      justify-content: center;
      z-index: 1051;
      div {
        width: 655px;
        height: 77px;
        text-align: center;
        background: url('./img/headerBackground.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        span {
          font-size: 35px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: rgba(202, 155, 84, 1);
          line-height: 64px;
        }
        // object-fit: contain;
      }
    }
    @include e(closeBtn) {
      position: absolute;
      top: -13px;
      right: 20px;
      width: 61px;
      height: 67px;
      z-index: 1051;
      cursor: pointer;
      background-image: url('./img/closeBtn.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      &:hover {
        background-image: url('./img/closeBtn-click.png');
      }
    }
  }
  @include e(body) {
    // width: 950px;
    width: 894px;
    min-height: 475px;
    // height: 510px;
    position: relative;
    background: url('./img/cardBackgrouond.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    object-fit: contain;
    overflow: hidden;
    @include e(content) {
      margin-top: 53px;
      margin-left: 93px;
      margin-right: 93px;
    }
    @include e(header) {
      display: flex;
      .header-title {
        // display: inline-block;
        max-width: 710px;
        font-size: 30px;
        // font-family:MicrosoftYaHei;
        // font-weight:400;
        // color:rgba(83,71,95,1);
        // line-height:42px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
    }
    @include e(optionContent) {
      margin-top: 19px;
      .option {
        width: 323px;
        height: 43px;
        padding-left: 10px;
        margin-bottom: 16px;
        background: rgba(230, 226, 214, 1);
        border-radius: 21px;
        text-align: left;
        font-size: 26px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(83, 71, 95, 1);
        line-height: 43px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
      }
      .two-queue {
        overflow: hidden;
        .left-queue {
          float: left;
        }
        .right-queue {
          float: right;
          &::after {
            content: '';
            display: inline-block;
            height: 0;
            clear: both;
          }
        }
      }
      .one-queue {
        display: flex;
        .center-queue {
          margin: 0 auto;
          .shortOption {
            width: 323px;
          }
          .longOption {
            width: 719px;
          }
        }
      }
      .selected {
        background: rgb(255, 215, 104);
      }
    }
    @include e(tips) {
      text-align: center;
      font-size: 8x;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(255, 121, 94, 1);
      line-height: 34px;
    }
    @include e(btn) {
      text-align: center;
      margin-bottom: 18px;
      cursor: pointer;
      span {
        display: inline-block;
        vertical-align: middle;
        width: 285px;
        height: 81px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
      }
      .nextStep {
        background-image: url('./img/nextStep.png');
        &:hover {
          background-image: url('./img/nextStep-hover.png');
        }
        &:active {
          background-image: url('./img/nextStep-active.png');
        }
      }
      .toTest {
        background-image: url('./img/toTest.png');
        &:hover {
          background-image: url('./img/toTest-hover.png');
        }
        &:active {
          background-image: url('./img/toTest-active.png');
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/GradingQuestion/index.vue